import { render } from "./SalesDetails.vue?vue&type=template&id=a1d17284&scoped=true"
import script from "./SalesDetails.vue?vue&type=script&lang=js"
export * from "./SalesDetails.vue?vue&type=script&lang=js"

import "./SalesDetails.vue?vue&type=style&index=0&id=a1d17284&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d17284"]])

export default __exports__